import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'constants/index'
import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'

/**
 * Service to get Plo5 game tables only
 */
export const getPlo5GameTablesService = (data) => {
  return axiosInstanceService(METHOD_TYPES.get, 'poker/get-all-game-tables', {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.page,
    params: data
  })
}

/**
 * Service to take seat in Plo5 game
 * @param {object} data - object contains { tableId, seatNumber, buyInAmount, gameType: 'Plo5' }
 */
export const takePlo5SeatService = (data) => {
  const Plo5Data = {
    ...data,
    gameType: 'plo5'
  }

  return axiosInstanceService(METHOD_TYPES.post, 'poker/take-seat', Plo5Data, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

/**
 * Service to take Plo5 game action (call, bet, raise, check, fold)
 * @param {object} data - object contains { tableId, roundId, action, betAmount?, gameType: 'Plo5' }
 */
export const takePlo5ActionService = (data) => {
  const Plo5Data = {
    ...data,
    gameType: 'plo5'
  }

  return axiosInstanceService(METHOD_TYPES.post, 'poker/take-action', Plo5Data, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

/**
 * Service to update Plo5 player sitting status (direct sit-out/return)
 * @param {object} data - object contains { tableId, sittingOut, sitOutType?, gameType: 'Plo5' }
 */
export const updatePlo5PlayerSittingStatusService = (data) => {
  const payload = {
    tableId: data.tableId,
    sittingOut: data.sittingOut,
    gameType: 'plo5'
  }
  if (data.sittingOut && data.sitOutType) {
    payload.sitOutType = data.sitOutType
  }
  return axiosInstanceService(METHOD_TYPES.post, 'poker/update-player-sitting-status', payload, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

/**
 * Service to update Plo5 player "Sit Out Next BB" flag
 * @param {object} data - object contains { tableId, sitOutNextBB, gameType: 'Plo5' }
 */
export const updatePlo5PlayerSitOutNextBBService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'poker/update-player-sit-out-next-bb', {
    tableId: data.tableId,
    sitOutNextBB: data.sitOutNextBB,
    gameType: 'plo5'
  }, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

/**
 * Service to update Plo5 buy-in amount
 * @param {object} data - object contains { tableId, newAmount, gameType: 'Plo5' }
 */
export const updatePlo5BuyInAmountService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'poker/update-buyIn-amount', { ...data }, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

/**
 * Service to change seat in Plo5 game
 * @param {object} data - object contains { tableId, fromSeat, toSeat, gameType: 'Plo5' }
 */
export const changePlo5SeatService = (data) => {
  return axiosInstanceService(METHOD_TYPES.put, 'poker/change-seat', { ...data, gameType: 'plo5' }, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

/**
 * Service to submit run it twice decision
 * @param {object} data - object contains { tableId, roundId, decision: 'ACCEPTED' | 'DECLINED' }
 */
export const runItTwiceDecisionService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'poker/run-it-twice/decision', data, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}
